import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "create-icon",
  "use": "create-icon-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol viewBox=\"0 0 38 38\" id=\"create-icon\">\n  <path d=\"M19.0001 2.42856V35.5714M2.42871 19H35.5716\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol